import { render } from "./brands.vue?vue&type=template&id=4791516b"
import script from "./brands.vue?vue&type=script&lang=js"
export * from "./brands.vue?vue&type=script&lang=js"

import "./brands.vue?vue&type=style&index=0&id=4791516b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__